import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getRole } from '../api';
import { hasRole } from './attendance/roles';

/**
 * Gate a route on a valid session and, optionally, on the user's role.
 *
 * The API enforces the same rules server-side; this only keeps people from
 * landing on a screen they cannot use.
 */
const ProtectedRoute = ({ roles, children }) => {
  const location = useLocation();
  const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  if (roles && !hasRole(getRole(), roles)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
